import { useEffect, useRef } from 'react';

const useDidUpdate = (f, conditions) => {
  const didMountRef = useRef(false);
  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    // Only call f if it's a function
    if (typeof f === 'function') {
      f();
    }
  }, conditions);
};

export default useDidUpdate;
